import React, { useState } from "react";
import { FaBuilding } from "react-icons/fa";

import i1 from "../Assets/Clients/azad4x4 logo.jpg";
import i2 from "../Assets/Clients/incrediblesculptures logo.webp";
import i3 from "../Assets/Clients/indiaincredible logo.webp";
import i4 from "../Assets/Clients/lightkraft logo.png";
import i5 from "../Assets/Clients/mahaveer tent logo.png";
import i6 from "../Assets/Clients/sunilhealth care logo.jpg";
import i7 from "../Assets/Clients/urbiz logo.webp";

const clients = [
  { name: "Mahindra", img: i1 },
  { name: "Ford", img: i2 },
  { name: "MTV", img: i3 },
  { name: "DuPont", img: i4 },
  { name: "CBRE", img: i5 },
  { name: "Hella", img: i6 },
  { name: "DD", img: i7 },
  { name: "Hella", img: i6 },
  { name: "DuPont", img: i4 },
  { name: "Ford", img: i2 },
  { name: "Mahindra", img: i1 },
  { name: "MTV", img: i3 },
  { name: "CBRE", img: i5 },
  { name: "DD", img: i7 },
];

// CLIENT ITEM
const ClientItem = ({ client }) => {
  const [error, setError] = useState(false);

  return (
    <div className="w-[150px] h-[90px] flex items-center justify-center bg-white rounded-md border shadow-sm flex-shrink-0 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 hover:border-teal-500 cursor-pointer">
      {!error ? (
        <img
          src={client.img}
          alt={client.name}
          onError={() => setError(true)}
       className="h-10 object-contain transition-transform duration-300 hover:scale-110"
        />
      ) : (
        <FaBuilding className="text-3xl text-gray-400" />
      )}
    </div>
  );
};

const OurClient = () => {
  const [rows, setRows] = useState(1);

  const handleLoadMore = () => {
    setRows(2);
  };

  return (
<section className="bg-[#fff2e2] py-12 px-4 sm:px-6 lg:px-20">
<h2 className="text-center text-3xl sm:text-4xl font-bold mb-10 text-black">
  Our <span className="text-teal-600">Clients</span>
</h2>

      {/* ROWS */}
      <div className="space-y-6">
        {[...Array(rows)].map((_, rowIndex) => {
          const rowData =
            rowIndex === 0
              ? clients
              : [...clients].reverse(); // 🔥 reverse only second row

          return (
            <div key={rowIndex} className="overflow-hidden">
              <div className="flex gap-6 animate-marquee">
                {[...rowData, ...rowData].map((client, i) => (
                  <ClientItem key={i} client={client} />
                ))}
              </div>
            </div>
          );
        })}
      </div>

      {/* BUTTON */}
      {rows < 2 && (
        <div className="flex justify-center mt-10">
          <button
            onClick={handleLoadMore}
            className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-3 rounded-md font-semibold"
          >
            LOAD MORE
          </button>
        </div>
      )}

      {/* ANIMATION STYLE */}
      <style>
        {`
          @keyframes marquee {
            0% {
              transform: translateX(0%);
            }
            100% {
              transform: translateX(-50%);
            }
          }

          .animate-marquee {
            display: flex;
            width: max-content;
            animation: marquee 60s linear infinite;
          }
        `}
      </style>
    </section>
  );
};

export default OurClient;